import { render } from "./PriceBreakdown.vue?vue&type=template&id=38540f15&scoped=true"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js"

import "./PriceBreakdown.vue?vue&type=style&index=0&id=38540f15&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38540f15"]])

export default __exports__